"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CotUtil = void 0;
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const CotConstant_1 = require("./CotConstant");
class CotUtil {
    static getMaxIndexByFlow(flow) {
        const nodeIds = flow.graph.nodes
            .map(x => x.id)
            .filter(id => !(0, is_blank_1.default)(id))
            .map(id => id.replaceAll(/[a-zA-Z]/gi, ""))
            .map(id => +id)
            .sort((a, b) => {
            return a - b;
        });
        const edgeIds = flow.graph.edges
            .map(edge => edge.id)
            .map(id => id.replaceAll(/[a-zA-Z-]/gi, ""))
            .map(id => +id)
            .sort((a, b) => {
            return a - b;
        });
        const maxNodeIndex = !(0, is_blank_1.default)(nodeIds) ? Math.max(...nodeIds) + 1 : 1;
        const maxEdgeIndex = !(0, is_blank_1.default)(edgeIds) ? Math.max(...edgeIds) + 1 : 0;
        return Math.max(maxNodeIndex, maxEdgeIndex);
    }
    static createNode(params, initData = {}) {
        const nodeType = params.data?.node_type;
        const prefix = params.data?.group ? "group" : "editor";
        const id = `${prefix}-${params.id}`;
        const displayType = this.getNodeDisplayType(nodeType);
        const showWarning = this.getShowWarning(nodeType);
        return {
            id: id,
            type: "customNode",
            data: {
                ...initData,
                displayType,
                showWarning,
                isResized: false,
                loadingNodeHtml: false,
                showUploadFile: true,
                showStopGenerateBtn: false,
                showFeedback: false,
                fromList: false,
                textAreaValue: params.data?.content || "",
                ownPlaceholder: true,
                inputTitle: params.data?.name,
                originId: "",
                parentNode: "",
                parentNodeId: "",
                childNode: [],
                chatBoxParam: [],
                dropUploadFileData: {},
                abortNode: {},
                functionType: params.data?.function_type,
                placeholder: params.data?.description,
            },
            position: {
                x: (params.position?.x || 0) * 500,
                y: (params.position?.y || 0) * 500,
            },
        };
    }
    static createOutput(node) {
        const isGroup = CotConstant_1.CotConstant.isGroupTypes.includes(node.data?.functionType ?? "");
        const groupId = isGroup ? node.id.replaceAll("editor", "group") : "";
        const nodeId = isGroup ? "" : node.id;
        const previewId = `${groupId}**${nodeId}`;
        return {
            angle: "",
            implication: "",
            modifier: "",
            reason: "",
            groupId: groupId,
            grid: false,
            results: [
                {
                    previewId,
                    blank: {
                        title: node.data.inputTitle,
                    },
                    nodeId,
                    parentNode: groupId,
                    fontSize: "Normal",
                    layout: "textBeautify",
                    angles: [],
                    dislikes: [],
                    filters: [],
                    likes: [],
                    reactions: [],
                    thought: "",
                },
            ],
        };
    }
    static createEdgeNode(params, initData = {}) {
        return {
            id: params.id,
            type: "customNewEdge",
            zIndex: 1,
            data: {
                ...initData,
                flows: params.flows,
                isGetQuery: true,
                getQueryLoading: false,
                isCreatedBySlice: false,
                isSliceAutoRun: false,
                isApiFunction: false,
                isUndoRedoAdd: false,
                isFromSaveData: false,
                originSource: "",
                originTarget: "",
                sourceHandle: "b",
                targetHandle: "a",
                selectedApi: {},
                lineParam: {
                    enterText: params.enterText,
                    loading: false,
                    queryValue: "",
                    lineType: "identifier",
                    createFromCot: true,
                    disabledRun: false,
                    id: "new-edge-2",
                },
                textAreaValue: "",
                targetNodeId: params.targetId,
                targetLineId: params.targetLineId ?? "",
            },
            position: params.position,
        };
    }
    static createLine(params, initData = {}, isSource = false) {
        return {
            id: params.id,
            source: params.source,
            target: params.edgeNodeId,
            sourceHandle: "b",
            targetHandle: "a",
            type: "customNewLine",
            markerEnd: isSource ? CotConstant_1.CotConstant.transparentMarkerEnd : CotConstant_1.CotConstant.defaultMarkerEnd,
            style: CotConstant_1.CotConstant.defaultLineStyle,
            data: {
                ...initData,
                sourceHandle: "b",
                targetHandle: "a",
                lineParam: {
                    lineType: "identifier",
                    createFromCot: true,
                    enterText: params.textAreaValue,
                },
            },
        };
    }
    static getShowWarning(nodeType) {
        const type = nodeType.toLocaleLowerCase();
        return (0, is_blank_1.default)(CotConstant_1.CotConstant.nodeTypeMap[type]);
    }
    static getNodeDisplayType(nodeType) {
        const type = nodeType.toLocaleLowerCase();
        const transtype = CotConstant_1.CotConstant.nodeTypeMap[type] ?? "text";
        if (CotConstant_1.CotConstant.uploadTypes.includes(transtype)) {
            return "uploadFile";
        }
        return transtype;
    }
}
exports.CotUtil = CotUtil;
